module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('block', {
    ref: "logo",
    staticClass: "logo",
    attrs: {
      "id": "logo",
      "cols": "1fr 1fr 1fr",
      "rows": "1fr 1fr 1fr",
      "pattern": "a b c, d e f, g h i"
    }
  }, [_c('span', {
    slot: "a"
  }), _vm._v(" "), _c('span', {
    slot: "b"
  }), _vm._v(" "), _c('span', {
    slot: "c"
  }), _vm._v(" "), _c('span', {
    slot: "d"
  }), _vm._v(" "), _c('span', {
    slot: "e"
  }), _vm._v(" "), _c('span', {
    slot: "f"
  }), _vm._v(" "), _c('span', {
    slot: "g"
  }), _vm._v(" "), _c('span', {
    slot: "h"
  }), _vm._v(" "), _c('span', {
    slot: "i"
  })]), _vm._v(" "), _c('h1', [_vm._v("vue-block")]), _vm._v(" "), _c('block', {
    staticClass: "menu"
  }, [_c('a', {
    class: _vm.selected === 0 ? 'selected' : '',
    attrs: {
      "href": "###"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchMenu(0)
      }
    },
    slot: "center"
  }, [_vm._v("Document")]), _vm._v(" "), _c('a', {
    class: _vm.selected === 1 ? 'selected' : '',
    attrs: {
      "href": "###"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.switchMenu(1)
      }
    },
    slot: "center"
  }, [_vm._v("Example")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected === 0),
      expression: "selected === 0"
    }],
    staticClass: "readme",
    domProps: {
      "innerHTML": _vm._s(_vm.readme)
    }
  }), _vm._v(" "), _c('example', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selected === 1),
      expression: "selected === 1"
    }]
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://github.com/0067ED/vue-block/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "right": "0",
      "z-index": "999",
      "border": "0"
    },
    attrs: {
      "alt": "Fork on GitHub",
      "src": "https://camo.githubusercontent.com/38ef81f8aca64bb9a64448d0d70f1308ef5341ab/68747470733a2f2f73332e616d617a6f6e6177732e636f6d2f6769746875622f726962626f6e732f666f726b6d655f72696768745f6461726b626c75655f3132313632312e706e67",
      "data-canonical-src": "https://s3.amazonaws.com/github/ribbons/forkme_right_darkblue_121621.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-223275af","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 215
// module chunks = 1